import React from "react";
import dash from "../img/dashed.png"
import AboutArray from "../Arrays/AboutArray";



// import Modal from 'react-bootstrap/Modal';
import { useState } from 'react'

const About = () => {
    // const sizeArry = AboutArray.map(media => media.size);



    const [modalShow, setModalShow] = useState(false);
    const [imgVal, setImgVal] = useState("");
    const [caption, setCaption] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);

    const imgArry = AboutArray.map((media) => media.img);


    const closeModal = () => {
        setModalShow(false);
        setImgVal("");
        setCaption("");
    };

    const prevImg = () => {
        const newIndex = (currentIndex - 1 + imgArry.length) % imgArry.length;
        setCurrentIndex(newIndex);
        setImgVal(imgArry[newIndex]);
    };

    const nextImg = () => {
        const newIndex = (currentIndex + 1) % imgArry.length;
        setCurrentIndex(newIndex);
        setImgVal(imgArry[newIndex]);
    };

    const ImgElement = (props) => {
        return (
            <>
                <span className={`${props.position} cursor-pointer`} >
                    <img src={props.img} alt='' className="media" onClick={() => { setModalShow(true); setImgVal(props.img) }} />
                </span>
            </>
        )
    }
    
    return (
        <>
            <div className="container mt-5 " id="About">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <h2 className="Headers mb-0 fs-lg-3 fs-md-3 fs-sm-2">About Wheelchair Cricket</h2>
                        <img src={dash} className="mx-auto" alt="" />
                    </div>
                    <div className="row">
                        <div className="col-md-7 my-auto">
                            <p className="text-justify paragraph">Mumbai city is known as the cricket capital of India, Mumbai has set records by winning the prestigious Ranji Trophy 41 times. Mumbai has produced great cricketers like Ajit Wadekar, Sunil Gavaskar, Sachin Tendulkar, Rohit Sharma & many more who contributed to Indian cricket. Even in the Indian Premier League, Mumbai Indians have won more championships than any other team. </p>
                            <p className="text-justify paragraph">Unfortunately, the city does not have its own Wheelchair Cricket Team for wheelchair cricketers of Mumbai & to change this Wheelchair Sports Association Mumbai has taken an initiative & formed the Mumbai Wheelchair Cricket Team. The Mumbai team will provide more opportunities to wheelchair cricketers across Mumbai & Maharashtra to play at the national & international levels.  </p>
                            <p className="text-justify paragraph">Wheelchair cricketers are 70% to 90% physically challenged, they have major disabilities in their lower body. They do batting, bowling & fielding on wheelchairs. The team includes players with different disabilities like polio, spinal cord injuries, cerebral palsy & even amputees. Mumbai Wheelchair Cricket Team is managed by Wheelchair Sports Association Mumbai and it does not have any support from Mumbai Cricket Association (MCA), BCCI, or any other government body. Wheelchair Sports Association Mumbai is registered under the Societies Act, 1860 & it is affiliated with Wheelchair Cricket India Association which manages the Indian Wheelchair Cricket Team.</p>
                            {/* <button className="btn btn-success bg-gradient shadow" >Read More</button> */}
                        </div>
                        <div className="col-md-5 my-auto" >
                            <div className="media-container">
                                {/* <MyVerticallyCenteredModal show={modalShow} onHide={() => setModalShow(false)} img={imgVal} size={imgsize} /> */}
                                {AboutArray.map((value, index) => {
                                    return (
                                        <ImgElement img={value.img} key={index} size={value.size} position={value.position} />
                                        // <img
                                        //     src={value.img}
                                        //     key={index}
                                        //     // alt=""
                                        //     size={value.size} 
                                        //      position={value.position}
                                        //     className="img-thumbnail m-2"
                                        //     onClick={() => openModal(value.img, index)}
                                        //     // style={{ maxWidth: "200px", cursor: "pointer" }}
                                        // />
                                    )
                                })}

                                {modalShow && (
                                    <div
                                        className="custom-modal-overlay"
                                        style={{
                                            position: "fixed",
                                            top: 0,
                                            left: 0,
                                            width: "100vw",
                                            height: "100vh",
                                            backgroundColor: "rgba(0,0,0,0.9)",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            zIndex: 9999,
                                        }}
                                    >
                                        {/* Close Button */}
                                        <span
                                            onClick={closeModal}
                                            style={{
                                                position: "absolute",
                                                top: "20px",
                                                right: "30px",
                                                color: "#fff",
                                                fontSize: "30px",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                zIndex: 1000,
                                            }}
                                        >
                                            &times;
                                        </span>

                                        {/* Prev Button */}
                                        <button
                                            onClick={prevImg}
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "20px",
                                                transform: "translateY(-50%)",
                                                fontSize: "2rem",
                                                color: "#fff",
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                            }}
                                        >
                                            &#10094;
                                        </button>

                                        {/* Image */}
                                        <img
                                            src={imgVal}
                                            alt=""
                                            style={{
                                                maxWidth: "90vw",
                                                maxHeight: "90vh",
                                                objectFit: "contain",
                                                boxShadow: "0 0 20px #000",
                                            }}
                                        />

                                        {/* Next Button */}
                                        <button
                                            onClick={nextImg}
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "20px",
                                                transform: "translateY(-50%)",
                                                fontSize: "2rem",
                                                color: "#fff",
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                            }}
                                        >
                                            &#10095;
                                        </button>

                                        {/* Caption */}
                                        {caption && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    bottom: "20px",
                                                    color: "#fff",
                                                    textAlign: "center",
                                                    width: "100%",
                                                }}
                                            >
                                                {caption}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default About